import parse from "html-react-parser";
import Link from "next/link";
import React from "react";

type Props = {
  locationName: string;
  classList: string[];
  url: string;
  title?: string;
  hasElectricCars?: boolean;
};

const AvailableClasses = (props: Props) => {
  const length = props.classList.length;
  const viewLength = props.hasElectricCars ? 5 : 6;
  const [slice, setSlice] = React.useState(viewLength);

  return (
    <div className=" pt-[30px]">
      <div className="mx-auto max-w-7xl px-[16px]">
        <div className="w-full">
          <div className=" mb-[18px] flex justify-between items-center">
            <h2 className="text-base font-extrabold lg:text-3xl text-my-dark-blue">
              {props.title
                ? props.title
                : `Rental Car Classes available in ${props.locationName}`}
            </h2>
          </div>
          <div
            className="pb-8 space-y-6 text-sm font-normal lg:pb-0 text-my-light-blue lg:font-light lg:text-base"

          >
            {/* 
              the map function basically transforms the array of strings from ["compact", "intermediate", "standard_suv"] to a single string like "Compact, Intermediate, or Standard SUV"
              Sorry for the really bad readability, but I wanted to get it done short and quick.
            */}
            {parse(`<p>
            Rental car companies at ${
              props.locationName
            } offer users a wide range of car options. Whether you are looking for ${props.classList
              .slice(0, 6)
              .map((item) =>
                item
                  .replace(/(^|\s)\S/g, (match) => match.toUpperCase())
                  .replace("-", " ")
              )
              .join(", ")
              .replace(/, ([^,]*)$/, " or $1")}, you can find one at  ${
              props.locationName
            }. </p><p>You have a lot to choose from. Click on the car class you want to rent from below to find the available deals.</p>`)}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 py-4 mt-[18px] lg:grid-cols-6 md:grid-cols-4">
          {props.hasElectricCars && (
            <Link
              href={`/${props.url}/electric-car`}
              className="transition-all hover:scale-105 aspect-[263/210] bg-white rounded-[22px] flex items-center justify-center flex-col border-[#EEEEEE] hover:shadow-custom shadow-none gap-[8px] group"
            >
              <img
                loading="lazy"
                alt={`electric car`}
                src={`/cars/class-img/ELECTRIC.png`}
                className="max-w-[128px] group-hover:scale-[1.2] transition-transform"
              />
              <p className="transition-all group-hover:scale-[0.9] group-hover:translate-y-2">
                Electric
              </p>
            </Link>
          )}

          {props.classList.slice(0, slice).map((className) => (
            <Link
              href={`/${props.url}/class/${className}`}
              className="transition-all hover:scale-105 aspect-[263/210] bg-white rounded-[22px] flex items-center justify-center flex-col border-[#EEEEEE] hover:shadow-custom shadow-none gap-[8px] group"
              key={className}
            >
              <img
                loading="lazy"
                alt={`${className.toLowerCase()} car`}
                src={`/cars/class-img/${className
                  .toUpperCase()
                  .replaceAll("-", "_")}.png`}
                className="max-w-[128px] group-hover:scale-[1.2] transition-transform"
              />
              <p className="transition-all group-hover:scale-[0.9] group-hover:translate-y-2">
                {className
                  .replaceAll("-", " ")
                  .replace(/(^|\s)\S/g, (match) => match.toUpperCase())}
              </p>
            </Link>
          ))}
        </div>
        <div className="flex justify-end w-full">
          {length > 6 && (
            <button
              className="pr-3 text-sm font-semibold text-my-dark-blue hover:underline"
              onClick={() => setSlice(slice === length ? viewLength : length)}
            >
              {`Show ${slice === length ? "Less" : "More"}`}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AvailableClasses;
